export default ".txt-bold {\n  font-weight: bold;\n  font-size: 1.3em;\n}";